
(function ($, Drupal) {
  $(document).ready(function () {
// reframe remote videos
  reframe('iframe.media-oembed-content, video');
})})(jQuery, Drupal);
